<template>
    <validation-observer ref="form" v-slot="{ meta }">
        <modal id="compose-modal-id" title="Send Message" scrollable :static="true" class="send-email-modal" @shown="setData">
            <busy-modal :show="busy"></busy-modal>

            {{ setInvalid(!meta.valid) }}
            <b-form @submit.prevent="">
                <b-row>
                    <b-col>
                        <validation-provider
                            name="subject"
                            v-slot="{ errors, handleChange }"
                            rules="required"
                        >
                            <form-input
                                floatingLabel="Subject"
                                v-model="subject"
                                :error="errors[0]"
                                @input="handleChange"
                            />
                        </validation-provider>
                    </b-col>
                </b-row>
                <b-row class="no-gutters">
                    <b-col md="9">
                        <validation-provider name="additional_attachment" v-slot="{ errors }">
                            <form-file
                                floating-label="Attachment"
                                placeholder="Upload and attach a remote file ..."
                                v-model="attachment"
                                :error="errors[0]"
                            ></form-file>
                        </validation-provider>
                    </b-col>
                    <b-col md="3" class="pl-2">
                        <b-button
                            class="right-button"
                            variant="warning"
                            @click="clearFile"
                            :disabled="isNil(attachment)"
                            >Clear</b-button
                        >
                    </b-col>
                </b-row>
                <validation-provider name="message" v-slot="{ errors, handleChange }" rules="required">
                    <lx-editor v-model="message" :error="errors[0]" @input="handleChange"></lx-editor>
                </validation-provider>
            </b-form>

            <template #modal-footer="{ cancel }">
                <div class="w-100">
                    <b-button variant="outline-primary" class="float-left" @click="clearMessage()"> Clear </b-button>
                    <b-button variant="primary" class="float-right ml-2" :disabled="!meta.valid" @click="sendEmail()">
                        Send
                    </b-button>
                    <b-button variant="secondary" class="float-right" @click="cancel()"> Cancel </b-button>
                </div>
            </template>
        </modal>
    </validation-observer>
</template>

<script>
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import API from '../../../../api';
import { ADMIN_SUBSCRIBER_COMMUNICATION } from '../../../../endpoints';
import FormInput from '../../../generic/form-input/form-input.vue';
import FormFile from '../../../generic/form-file/form-file.vue';
import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
import LxEditor from '../../../generic/lx-editor/lx-editor.vue';
import Modal from '../../../generic/modal/modal.vue';
import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
import { formatResponseError } from '../../../../utils/api';

export default {
    name: 'DamageProtectionSendEmailModal',
    components: {
        Modal,
        FormInput,
        FormTextarea,
        FormFile,
        LxEditor,
        BusyModal,
    },
    inject: ['userId'],
    data() {
        return {
            editorModules: {
                modules: {
                    toolbar: {
                        container: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ header: 1 }, { header: 2 }],
                            ['clean'],
                            [{ list: 'ordered' }, { list: 'bullet' }],
                        ],
                    },
                    htmlEditButton: {},
                },
            },
            attachment: null,
            message: null,
            subject: 'Message from Lodgix.com',
            invalid: false,
            busy: false,
        };
    },
    methods: {
        isNil,
        setInvalid(isInvalid) {
            this.invalid = isInvalid;
        },
        setData() {
            this.$refs.form.setValues({
                subject: this.subject,
                message: this.message,
            })
        },
        async sendEmail() {
            try {
                this.busy = true;
                const body = new FormData();

                body.append('subject', this.subject);
                body.append('email_body', this.message);
                body.append('additional_attachment', this.attachment || '');
                await API.post(`${ADMIN_SUBSCRIBER_COMMUNICATION(this.userId)}send-email/`, body, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                });
                this.$emit('emailSent');
                this.successToast({ text: 'Success' });
                this.message = '';
                this.attachment = null;
                this.$bvModal.hide('compose-modal-id');
            } catch (e) {
                const { generic, fields } = formatResponseError(e);
                if (!generic && !isEmpty(fields)) {
                    this.$refs.form.setErrors(fields);
                }
                if (generic) {
                    this.errorToast({ text: generic });
                } else {
                    this.errorToast({ text: 'Could not send email' });
                }
            } finally {
                this.busy = false;
            }
        },

        clearMessage() {
            this.message = this.userEmailSignature || '';
        },
        clearFile() {
            this.attachment = null;
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.modal-dialog) {
    max-width: 650px !important;
}

.cc-email-input {
    margin-left: 5px;
}

.right-button {
    width: 100%;
    height: 2.75rem;
}
</style>
